export default __webpack_public_path__ + "static/media/baker-street.aae83efa.svg";